// extracted by mini-css-extract-plugin
module.exports = {"content":"products_content__3P5i3","center":"products_center__2Kfds"};